<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12"
            ><advance-uploader
              :stencilProps="{ aspectRatio: 16 / 9 }"
              :stencilSize="false"
              cropTypeProp="محصول"
              :imagesProps="images"
              :imageFileIdsProps="product.imagesFileIds"
              @imagesFileIdsChange="(e) => (product.imagesFileIds = e)"
              @imagesChange="(e) => (images = e)"
            ></advance-uploader
          ></v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn @click="beforeStep()" color="secondery">
            بازگشت به مرحله قبل
        </v-btn>
        <v-btn
          @click="nextStep()"
          color="primary"
          v-if="
            categoryType == 'Product' || categoryType == 'ElectronicDocument'
          "
        >
           مرحله بعد
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import AdvanceUploader from '@/components/core/AdvanceUploader';
export default {
  components: {
    AdvanceUploader,
  },
  props: {
    categoryType: {
      default: null,
      type: String,
    },
    productImages: {
      default: [],
      type: Array,
    },
    imagesFileIds: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      images: [],
      product: {
        imagesFileIds: [],
      },
    };
  },
  created() {
    if (this.$store.getters.supplierProductSelectedForEdit) {
      if (
        this.$store.getters.supplierProductSelectedForEdit.images &&
        this.$store.getters.supplierProductSelectedForEdit.images.length
      ) {
        this.images = this.$store.getters.supplierProductSelectedForEdit.images;
        this.$store.getters.supplierProductSelectedForEdit.images.forEach(
          (element) => {
            this.product.imagesFileIds.push(element.fileId);
          }
        );
      }
    }
  },
  watch: {
    productImages(after, before) {
      if (after && after.length > 0) {
        this.images = after;
      }
    },
    imagesFileIds(after, before) {
      if (after && after.length > 0) {
        this.product.imagesFileIds = after;
      }
    },
  },
  methods: {
    beforeStep() {
      this.$emit('goToDetailStep');
    },
    nextStep() {
      if (this.product.imagesFileIds && this.product.imagesFileIds.length > 0) {
        const loader = this.$loading.show();
        this.$emit('selectProductImages', this.product);
        loader.hide();
      } else {
        this.$dialog.error({
          text: 'انتخاب عکس الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
  },
};
</script>

<style></style>
